import React from "react";

export const Input = ({ className, inputClassName, state, text, text1, value, onChange }) => {
  // 创建清除输入的处理函数
  const handleClear = () => {
    // 创建一个模拟的事件对象，包含一个 target 属性和 value 属性
    const event = { target: { value: '' } };
    onChange(event);
  };

  return (
    <div className={`flex flex-col w-[335px] items-start gap-[5px] relative ${className}`}>
      <div className="relative w-fit mt-[-1.00px] font-medium text-[#676C77] text-[15px] tracking-[0] leading-[normal]">
        {text}
      </div>
      <div className="relative w-full">
        <input
          className={`w-full h-[50px] px-[15px] py-0 bg-white rounded-[8px] border border-[#E5E7EB] font-normal text-[#1C1F25] text-[16px] tracking-[0] leading-[normal] ${value ? 'pr-[40px]' : ''} ${inputClassName}`}
          placeholder={text1}
          type="text"
          value={value}
          onChange={onChange}
        />
        {value && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-[12px] top-1/2 transform -translate-y-1/2 w-[20px] h-[20px] flex items-center justify-center rounded-full bg-[#E5E7EB] text-[#676C77] hover:bg-[#D1D5DB] focus:outline-none"
            aria-label="清除输入"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
